import * as React from 'react';
import { Icon } from './Icon';
import { PERSONA, type PersonaKey } from '@/lib/persona';

// Persona home hero band — gradient (persona tint → white), persona icon, title,
// subtitle, actions. Mirrors Docs/Design Handoff/portal/shell.jsx HomeHero.
export interface HomeHeroProps {
  persona: PersonaKey;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function HomeHero({ persona, title, subtitle, actions }: HomeHeroProps) {
  const p = PERSONA[persona];
  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, marginBottom: 22,
        padding: '18px 22px', borderRadius: 14, border: '1px solid var(--border)',
        background: `linear-gradient(100deg, ${p.tint} 0%, #fff 70%)`,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <span style={{ width: 44, height: 44, borderRadius: 11, background: p.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Icon name={p.icon} size={22} color="#fff" />
        </span>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-.01em' }}>{title}</h1>
          {subtitle && <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 3 }}>{subtitle}</p>}
        </div>
      </div>
      {actions && <div style={{ display: 'flex', gap: 8 }}>{actions}</div>}
    </div>
  );
}

export default HomeHero;
